import m from "mithril";
import { SvgIcon } from "../../common/MaterialDesignComponents";
import "./HotelPhotoGridBanner.css";

interface Attrs {
    photoUrls: string[],
    onViewMore?: () => void,
    onPhotoClick?: (index:number) => void
}

export default function HotelPhotoGridBanner(): m.Component<Attrs> {    
    return {
        view(vnode) {
            const {photoUrls, onPhotoClick, onViewMore} = vnode.attrs;
            const numItems = photoUrls.length;
            const numItemsToShow = (numItems >= 5)? 5 : (numItems >= 3)? 3 : 1;
            const className = "photo-grid-banner photo-grid-banner-" + numItemsToShow;

            const numberOfPhotosLabel = photoUrls.length + " " + 
                ((photoUrls.length > 1)? "Photos" : "Photo")

            return m("div", {class: className}, 
                photoUrls.slice(0, numItemsToShow).map((url, index) => 
                    m("img.photo-grid-banner-item", {
                        id: "photo-" + index,
                        src: url,
                        loading: "lazy",
                        onclick:(event) => {
                            if(onPhotoClick) {
                                onPhotoClick(index);
                            }
                        }
                    })
                ),
                m("div.bottom-overlay",                     
                    m("button", { 
                        class: "btn btn-sm text-white",
                        onclick: (event) => {
                            event.preventDefault();
                            if(onViewMore) {
                                onViewMore();
                            }
                        }
                    },
                        [
                            m(SvgIcon, {
                                iconType: "photo_size_select_actual"
                            }), 
                            m("span.mx-1", numberOfPhotosLabel)
                        ]                        
                    )                    
                )           
            );
        }
    }
}